import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Col,  Nav, Row, Tab } from "react-bootstrap";
import { useControl, useControlReducer } from "../../../controlContext";
import { CAT, MAS,REP_SEC, SUB } from "../../../../../shared/Data/typeDirs";
import { useSource } from "../../../sourceContext";
import { ChevronDown, ChevronUp } from 'react-feather'
import { useControlHeaderContext } from "../../../controlWrapperContext";
import { langTypeMap } from "../../../../../shared/Data/langTypeMap";
import { ReportV2 } from "../../../../../shared/Objects/newReportObjects/report_v2";
import { Input } from '@mui/joy';
import "../../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/categorySelector.css"

const CAT_LIST = [{ type: REP_SEC, label: 'SECTION' }, { type: MAS, label: 'GROUP' }, { type: CAT, label: 'CATEGORY' }, { type: SUB, label: 'SUBCATEGORY' }]
export function CategorySelector({
  name,
  idx
}) {

  const controls = useControl()
  const [selectedType, setSelectedType] = useState(false)
  const { [idx]: block } = controls
  const { settings: { readOnly: allReadOnly, lockMap } } = useControlHeaderContext()
  const readOnly = useMemo(() => (allReadOnly || (lockMap && lockMap[block._id])), [allReadOnly, lockMap, block._id])
  useEffect(()=>{setSelectedType(false)}, [readOnly])
  const source = useSource()
  const [blockNameStateBuffer, setBlockNameStateBuffer] = useState(false)
  useEffect(() => { setSelectedType(false) }, [block._id])
  useEffect(() => {
    if (blockNameStateBuffer === false) return
    let timeout_id = setTimeout(() => {
      controlReducer({ type: 'changed', idx, name: 'blockName', update: { blockName: blockNameStateBuffer } })
      setBlockNameStateBuffer(false)
    }, 200)
    return () => { clearTimeout(timeout_id) }
  })

  const blockName = useMemo(() => blockNameStateBuffer || block.blockName || '', [blockNameStateBuffer, block.blockName])
  const menuState = useMemo(() => {
    return {
      [REP_SEC]: source[REP_SEC].find(itm => itm._id === block[REP_SEC]),
      [MAS]: source[MAS].find(itm => itm._id === block[MAS]),
      [CAT]: source[CAT].find(itm => itm._id === block[CAT]),
      [SUB]: source[SUB].find(itm => itm._id === block[SUB]),
    }
  }, [block, source])
  const controlReducer = useControlReducer()

  function setSelectedCategoryType(evt) {
    // console.log('setting category type in CategorySelector', evt.target.name, evt.currentTarget.name)
    if (evt.currentTarget.name === selectedType) return setSelectedType(false)
    setSelectedType(evt.currentTarget.name)
  }
  const categoryController = readOnly? [] : [
    <CategorySelectorTabs 
        selectedType={selectedType} 
        setSelectedType={setSelectedType} 
        setSelectedCategoryType={setSelectedCategoryType} 
      />,
      <Row className="g-0 category-selector-row">
        <CategoryMenu
          name={name}
          idx={idx}
          type={selectedType}
          source={source}
          block={block}
          controlReducer={controlReducer}
        />
      </Row>
  ]
  return  (
    <div className="category-selector-button-container">
      {categoryController}
      {/* <Row style={{ paddingLeft: 20, color:'#589A99', fontWeight: 'bold', fontSize: 14}}>
        {`${menuState[REP_SEC].getDisplayText()} > ${menuState[MAS].getDisplayText()} > ${menuState[CAT].getDisplayText()}`}
      </Row> */}
      <Row className="g-0 category-selector-row category-title-row">
        <Col sm="3" className="category-title-section-col">
          <div className="category-section-text">
            {menuState[REP_SEC] && menuState[REP_SEC].getDisplayText()}
          </div>
        </Col>
        <Col sm="9" className="category-title-col">
          <div className="category-title">
            <span style={{ fontStyle: 'italic' }}>{menuState[SUB].fullNumber.slice(4)}</span>
            <Input
              readOnly={readOnly}
              className="block-name-control"
              placeholder="Block Name (Subcategory)"
              type="text"
              onChange={evt => setBlockNameStateBuffer(evt.target.value)}
              value={blockName} >
            </Input>
          </div>
        </Col>
      </Row>
    </div>
  )
}

function CategorySelectorTabs({ selectedType, setSelectedType }) {
  return (
    <Row className="g-0 category-selector-row button-row">
      <Tab.Container >
        <Nav
          className={`category-selector-tabs ${selectedType ? 'tabs-open' : ''}`}
          activeKey={selectedType}
          variant="tabs"
          onSelect={(key) => {
            console.log('category selector tabs onselect', key)
            if (selectedType === key) {
              setSelectedType(false)
            } else {
              setSelectedType(key)
            }
          }}>
          {CAT_LIST.map((itm, itmIdx) => (
            <Nav.Item 
              key={itmIdx} 
              className={`category-selector-tab ${itm.type} ${selectedType === itm.type ? 'active' : ''}`} >
              <Nav.Link 
                className={`category-selector-tab-label ${itm.type} ${selectedType === itm.type ? 'active' : ''}`} 
                eventKey={itm.type}>
                {itm.label}
                {itm.type === selectedType ? <ChevronUp /> : <ChevronDown />}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </Tab.Container>
    </Row>
  )
}

function CategoryMenu({ controls, block, type, source, controlReducer, name, idx }) {
  const { settings, setSettings } = useControlHeaderContext()
  // useEffect(() => { setFilteredSource(source) }, [source])
  const [requestLink, setRequestLink] = useState(false)
  useEffect(() => {
    if (requestLink) {
      scrollToThing(requestLink)
      setTimeout(() => setRequestLink(false))
    }
  }, [requestLink])


  const setClassificationToContents = useCallback((itm) => {

    const categoryOrder = [MAS, CAT, SUB]
    const categoryTypeIndex = categoryOrder.indexOf(itm.type)
    console.log('selected item from category list', itm, categoryTypeIndex)
    let update = { [itm.type]: itm._id, blockName: itm.type === SUB ? itm.content : block.blockName }

    if (~categoryTypeIndex) {
      let catsToClear = categoryOrder.slice(categoryTypeIndex + 1)
      for (let childType of catsToClear) {
        const sourceEntry = source[childType].find(
          itm => update[langTypeMap[itm.type].getParentKey()] === itm[langTypeMap[itm.type].getParentAddress()]
        )
        update[childType] = sourceEntry._id
        if (childType === SUB) update.blockName = sourceEntry.content
      }
    }
    controlReducer({ type: 'changed', name, idx, update })
    if ([REP_SEC, SUB].includes(itm.type)) {
    setTimeout(() => {
      controlReducer({ type: 'sort_blocks', sortFn: (a, b) => ReportV2.sortAllBlocks(a, b, source), name, idx, blockId: block._id })
      // setRequestLink(block._id)
      setSettings({ ...settings, sorted: true })
    }, 100)
    } else if (categoryOrder.includes(itm.type)) {
      setSettings({ ...settings, sorted: false })
    }
  }, [controlReducer, name, idx, settings, source, block])


  const languageMenuEntries = useMemo(() => {
    if (!type) return
    return source[type].filter(itm =>
      !langTypeMap[type].getParentKey() ||
      itm[langTypeMap[type].getParentAddress()] === block[langTypeMap[type].getParentKey()]
    )
  }, [type, source, block])


  return !type ? [] : (
    <div className="category-menu-container">
      <Row className="category-list-area g-0">
        {languageMenuEntries.map((itm, idx) => (
          <div
            key={idx}
            className={`g-0 category-language-list-item ${ itm._id === block[itm.type]? 'category-selected':''} ${![SUB, CAT, MAS].includes(itm.type) ? 'lang' : 'category'}`}
            onClick={() => setClassificationToContents(itm)}
          >
            <Col sm="2" className="category-list-title">
              <span >
                {itm.type === REP_SEC ? `Section ${itm.number}:` : `${itm.fullNumber}: `}
              </span>
            </Col>
            <Col className="category-list-content">
              <span >
                {itm.content}
              </span>
            </Col>
          </div>
        ))}
      </Row>
    </div>
  )
}

// {
//   [SUB, CAT, MAS].includes(itm.type) ? <><span className="category-list-title">{`${itm.fullNumber}: `}</span>{itm.content} </> :
//     <><span className="category-list-title">{`${itm.short}: `}</span> <span style={{display:'inline'}}>{itm.content}</span></>
// }

function getSubcategoryChangedData(subcategoryid, source, reportSection) {
  let subcategory = source[SUB].find(sub => sub._id === subcategoryid)
  let category = source[CAT].find(cat => cat._id === subcategory._categories)
  return {
    [REP_SEC]: reportSection,
    [SUB]: subcategory._id,
    [CAT]: category._id,
    [MAS]: category._mastercategories,
    blockName: subcategory.content
  }
}

function scrollToThing(blockId) {
  // blockNameTextRef.current.scrollIntoView()
  console.log('scrolling to block', blockId)
  // goToBlock(blockId)
  // history.replace({...history.location, hash:`#${blockId}`})
  document.getElementById(blockId).scrollIntoView({ behavior: 'smooth' })
  // window.scrollTo(0, top)
  // window.location = (""+window.location).replace(/#[A-Za-z0-9_]*$/,'')+ `#${blockId}`
}